const getFileExtension = (filename) => filename.split('.').pop();
export default getFileExtension;
